import { CookieLockOutlineIcon } from './CookieLockOutlineIcon';

/**
 * author: Colton Wiscombe
 * id CB5D57DF-BA59-4C98-9FA7-96536EF9FAA0
 * name cookie-lock-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie-lock-outline.svg
 * tags
 * - Food / Drink 
 * - Lock 
 */
export const BiscuitLockOutlineIcon = CookieLockOutlineIcon;
export default BiscuitLockOutlineIcon